const ChartWithNoteWrapper = ({
  totalHours,
  totalUsers,
  customMessage,
  children,
}) => {
  return (
    <>
      {children}
      <p style={{ textAlign: 'center', padding: 16 }}>
        {customMessage ? (
          <>{customMessage}</>
        ) : (
          <>
            {totalHours > 0 && totalUsers > 0 && (
              <>
                Cálculo leva em conta <b>{totalUsers} usuários</b> totalizando{' '}
                <b>{totalHours} horas</b> avaliadas no período
              </>
            )}
          </>
        )}
      </p>
    </>
  )
}

export default ChartWithNoteWrapper
